import {BToast} from "bootstrap-vue";
import store from "@/store";
export default function CompositionsApiComponents() {
  // ------------------------------------------------
  // taskLocal
  // ------------------------------------------------
    const showToast = (message,options) => {

        let bootStrapToaster = new BToast();

        bootStrapToaster.$bvToast.toast(message, {
            title: options.title ?? '',
            toaster: `b-toaster-top-${store.state.appConfig.isRTL ? 'left' : 'right'}`,
            variant: options.variant ?? 'info',
        })

    }


  return {
    showToast
  }
}
